import { render } from "./brand-logo.vue?vue&type=template&id=36c03f8c&scoped=true&ts=true"
import script from "./brand-logo.vue?vue&type=script&lang=ts"
export * from "./brand-logo.vue?vue&type=script&lang=ts"

import "./brand-logo.vue?vue&type=style&index=0&id=36c03f8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c03f8c"]])

export default __exports__